import Welcome from "../components/Welcome";

const WelcomePage = () => {
    return <div><Welcome/></div>
}

export default WelcomePage;